import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { gsap } from 'gsap';
export default {
  before: function before(_ref) {
    var current = _ref.current;
    current.container.classList.add('is-loading');
    setTimeout(function () {
      var videos = current.container.querySelectorAll('video');

      if (videos) {
        videos.forEach(function (obj) {
          obj.pause();
        });
      }
    });
  },
  leave: function leave(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var current;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              current = _ref2.current;
              return _context.abrupt("return", new Promise(function (resolve) {
                var tl = gsap.timeline({
                  onComplete: function onComplete() {
                    current.container.remove();
                    window.scrollTo(0, 0);
                    document.documentElement.classList.remove('menu-visible');
                    resolve();
                  }
                });
                tl.to(current.container, {
                  autoAlpha: 0,
                  duration: 0.6,
                  ease: 'power3.out'
                });
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeEnter: function beforeEnter(_ref3) {
    var next = _ref3.next;
    gsap.set(next.container, {
      autoAlpha: 0
    });
  },
  enter: function enter(_ref4) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var next;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              next = _ref4.next;
              return _context2.abrupt("return", new Promise(function (resolve) {
                next.container.classList.add('is-non-interactive');
                var tl = gsap.timeline({
                  onComplete: function onComplete() {
                    resolve();
                  }
                });
                tl.to(next.container, {
                  duration: 1.2,
                  autoAlpha: 1,
                  ease: 'power3.out'
                });
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  afterEnter: function afterEnter(_ref5) {
    var next = _ref5.next;
    next.container.classList.remove('is-non-interactive');
    next.container.style = '';
  }
};